// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"03d545e2","692":"0db6f865"}[chunkId] + ".chunk.js";
};